import random from './random';
export default function sample(arr) {
    return arr.at(~~random(0, arr.length));
}
;
